import { z } from 'zod'

export const memberResolvedSchema = z.object({
  programUuid: z.string().uuid(),
  masterTaskId: z.number(),
  memberStatus: z.string(),
  membersInFeed: z.number(),
  membersInRegularMode: z.number(),
  membersInChatMode: z.number(),
})
